import React, { useEffect } from 'react';
import styles from './PaymentInvoices.module.css';

const GenerationProgressModal = ({ isOpen, progress = 0, step = '', isDone = false, onDone }) => {
  useEffect(() => {
    if (isDone) {
      const timer = setTimeout(onDone, 2000);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [isDone, onDone]);

  if (!isOpen) return null;

  return (
    <div className={styles.modalBg}>
      <div className={styles.modalBox} style={{ width: 460, textAlign: 'center' }}>
        <div style={{ fontSize: 38, marginBottom: 14 }}>{isDone ? '✅' : '⚙️'}</div>
        <div style={{ fontFamily: 'Syne, sans-serif', fontSize: 16, fontWeight: 700, color: 'var(--ink)', marginBottom: 8 }}>
          {isDone ? '✅ All Done!' : 'Generating Invoices...'}
        </div>
        <div style={{ fontSize: 12.5, color: 'var(--ink3)', marginBottom: 16 }}>
          {isDone ? 'Invoices generated · emails sent · S3 uploaded' : step}
        </div>
        <div className={styles.progressBar}>
          <div className={styles.progressFill} style={{ width: `${progress}%` }} />
        </div>
        <div className={styles.progressPct}>{progress}%</div>
      </div>
    </div>
  );
};

export default GenerationProgressModal;
